@if (isEditViewAvailable()) {
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onEditClicked('')"
    icon="mode_edit"
    size="small"></pas-button-round>
}
@if (isDeleteViewAvailable()) {
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onDeleteClicked('')"
    icon="delete"
    size="small"></pas-button-round>
}
